  <div class="row mt-3" [formGroup]="numberFieldForm">
    <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}} label_disp">
      <label class="label" for="{{ fieldId }}">
        {{ displayName }}:
        <span *ngIf="required" id="mandatory_field">&#42;</span>
      </label>
    </div>

    <div class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12'  :'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
        <input class="form-control" *ngIf="fieldType === 1" id="{{ fieldId }}" type="text" (change)="numberValueFormatter()" formControlName="data"
        keyup="numberValueUpdate()" [(ngModel)]="customFieldValue" (focus)="numberFieldFocus = true" (blur)="numberFieldFocus = false"
        [ngClass]="{'error-class':numberFieldForm.controls['data'].touched && numberFieldForm.controls['data'].errors?.required}" maxlength="255" autocomplete="off">
        
      <div class="slidecontainer">

        <input class="range range-slider" *ngIf="fieldType === 0 && valueType === 0" id="{{ fieldId }}" type="range" data-show-value="true"
          data-popup-enabled="true" min="1" max="5" value="{{ defaultValue }}" formControlName="data" [(ngModel)]="customFieldValue">
        <input class="range range-slider" *ngIf="fieldType === 0 && valueType === 1" id="{{ fieldId }}" type="range" data-show-value="true"
          data-popup-enabled="true" min="1" max="10" value="{{ defaultValue }}" formControlName="data" [(ngModel)]="customFieldValue">
        <input *ngIf="fieldType === 0" readonly="true" class="range-slider-output" id="{{ fieldId }}_output" value="{{customFieldValue}}"
          type="text" autocomplete="off">
      </div>

      <div *ngIf="numberFieldForm.controls['data'].touched && numberFieldForm.controls['data'].errors?.required" class="validation-error-inline text-danger">
        {{ displayName }} {{ 'CustomField.fieldRequired' | translate }}
      </div>

      <div *ngIf="fieldType === 0 && numberFieldForm.controls['data'].touched && (numberFieldForm.controls['data'].errors?.min || numberFieldForm.controls['data'].errors?.max)"
        class="validation-error-inline text-danger">
        {{ displayName }} {{ 'CustomField.outOfRange' | translate }}
      </div>
    </div>

    <span *ngIf="dscEnable === 1" [attr.data-toggle]="fieldId" data-trigger="hover" [attr.data-content]="description" class="custom_align_desc_icon"
    [ngClass]="{'align_description_icon' :fieldType === 1}">
      <em class="fa fa-question-circle fa-lg"></em>
  </span>
  </div>
